require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/object/create.js
// module id = 1013
// module chunks = 48 49 50